export default __webpack_public_path__ + "static/media/checkColor.7f5bf257.svg";